RivalIQ.apps.Dashboard.module('mixins', function (mixins, App, Backbone, Marionette, $, _) {

    'use strict';

    /*
     * HACK HACK
     * This function should be replaced by flexbox. But until we are confident
     * in its performance in IE 10, this replacement normalizes heights between
     * multiple col-* elements by expanding .flex-regions
     */
    function normalizeHeights(el) {
        _.defer(function () {
            const $el = $(el).addClass('full-height');
            const elms = $(el).parents('.x-normalize-heights').parent().children();

            if (_.size(elms) < 2) {
                return;
            }

            const flexRegions = elms.find('.flex-region');
            flexRegions.addClass('flex-region-hidden');

            const heights = _.map(elms, function (el) {
                return $(el).height();
            });

            const max = Math.max.apply(null, heights);

            _.forEach(elms, function (el, i) {
                const diff = max - heights[i];
                const region = $(el).find('.flex-region').last();
                region.css('height', diff);

                // Dont display the element w/ height 0 so we dont get double
                // borders
                if (diff) {
                    region.removeClass('flex-region-hidden');
                }

                $el.toggleClass('full-height', !diff);
            });
        });
    }

    mixins.NormalizeHeights = {

        afterConstruction: function () {
            const me = this;

            me.resizeHandler = function () {
                normalizeHeights(me.el);
            };

            me.listenTo(me, 'loading:finished', me.resizeHandler);
            me.listenTo(me, 'render:async', me.resizeHandler);
            $(window).on('resize', me.resizeHandler);

            me.listenTo(me, 'destroy', function () {
                $(window).off('resize', me.resizeHandler);
            });
        }
    };
});
